import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { Section } from "../section";
import { AssignmentGeneralDetail } from "./detail";

export interface AssignmentGeneralProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentGeneral = ({ campaign }: AssignmentGeneralProps) => {
    const { t } = useTranslation(["common"]);

    const [isCollapsed, { toggle: toggleCollapse }] = useDisclosure(false);

    return (
        <Section title={t("campaign_general")} isCollapsed={isCollapsed} onClick={toggleCollapse}>
            <AssignmentGeneralDetail campaign={campaign} />
        </Section>
    );
};
